app.service("ProductDoorSlopingCalculatorService", ['$rootScope', 'ProductService', function ($rootScope, ProductService) {

    const service = this;

    const siteHelper = $rootScope.site_helper;
    const modelConstructor = $rootScope.model_constructor;


    //Note. Theoretically this service would be used for multiple "applied" scenarios
    //however currently the bella door_sloping_calculator is the only thing that uses it,

    const ProductDoorSlopingModel = modelConstructor.extend(ProductService.BasicProductModel, {
        id: "product_door_sloping_calculator",
        applyItemHandler: applyItemHandler,
        is_single_item_model: true,
        base_component_id: "door",
        parent_category_id: "door_sloping_calculator"
    });

    this.factory = new ProductService.BasicProductModelFactory({
        birth: function (values) {
            return new ProductDoorSlopingModel(values);
        }
    });

    function applyItemHandler(product) {

        this.super(product);

        const model = this.root;

        product.option_layout = "list";
        product.name = "Sloping Door Calculator";
        product.group_name = product.name;
        product.quantity = 1;
        product.doors = '';
        product.height = '';
        product.width = '';

        product.door_sloping_count = '';

        product.default_midrail_height = 655;

        product.calculated_price = 0;

        product.applynonstdsurcharge = false;
        product.door_products = [];
        product.local_option_term_config = [
            {
                option_id: "handle_position_knebworth",
                required: true
            },
            {
                option_id: "door_sloping_angle",
                required: true
            },
            {
                option_id: "door_sloping_spacing"
            },
            {
                option_id: "midrail",
                required: true
            }
        ]

        siteHelper.applyValues(product, {
            collectImageParams: function () {
                const params = this.super();

                params.image_type_id = "product";
                params.site_range_id = $rootScope.navigation_model.state_ids.site_range_id;
                params.colour_id = $rootScope.navigation_model.state_ids.colour_id;
                params.style_id = $rootScope.navigation_model.state_ids.style_id;
                params.api_code = product.api_code;
                params.product_width = product.width;
                params.product_height = product.height;

                params.rotate_grain = product.rotate_grain;

                params.midrail = product.option_term_values.midrail ? product.option_term_values.midrail.midrail_height : null;

                params.left_angle_height = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_height : null;
                params.left_angle_width = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_width : null;
                params.right_angle_height = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_height : null;
                params.right_angle_width = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_width : null;

                params.doors = product.door_sloping_count;

                params.door_spacing = product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.door_spacing : null;

                params.left_spacing = product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.left_spacing : null;
                params.right_spacing = product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.right_spacing : null;
                params.top_spacing = product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.top_spacing : null;
                params.bottom_spacing = product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.bottom_spacing : null;

                params.left_angle_spacing = product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.left_angle_spacing : null;
                params.right_angle_spacing = product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.right_angle_spacing : null;

                if (product.door_products) {
                    const doorOptions = [];
                    for (let i = 0; i < product.door_sloping_count; i++) {
                        const doorProduct = product.door_products[i];
                        let doorOption;
                        if (doorProduct) {
                            doorOption = service.collectDoorProductImageParams(doorProduct, product, {});
                            if (doorProduct.inputted_width) {
                                doorOption.product_width = doorProduct.inputted_width;
                            }
                            delete doorOption.product_height;
                            delete doorOption.left_angle_height;
                            delete doorOption.left_angle_width;
                            delete doorOption.right_angle_height;
                            delete doorOption.right_angle_width;
                        } else {
                            doorOption = {};
                        }
                        doorOption.handle_position = product.option_term_ids.handle_position_knebworth;

                        doorOptions.push(doorOption)
                    }
                    params.door_options = doorOptions;
                }

                return params;
            },
            finalPrice: function () {
                if (product.calculated_price) {
                    return product.calculated_price;
                }
                return this.super();
            }
        });

    }

    this.getDoorProductHingeHoles = function (doorProduct) {

        if (doorProduct.drillside !== '' && doorProduct.drillside !== null && doorProduct.drillside !== undefined) {

            const fromTop = [];
            const fromBottom = [];

            if (doorProduct.drill_0 !== "" && doorProduct.drill_0 !== undefined) {
                fromTop.push(doorProduct.drill_0);
            }

            if (doorProduct.drill_1 !== "" && doorProduct.drill_1 !== undefined) {
                fromTop.push(doorProduct.drill_1);
            }

            if (doorProduct.drill_2 !== "" && doorProduct.drill_2 !== undefined) {
                fromBottom.push(doorProduct.drill_2);
            }

            if (doorProduct.drill_3 !== "" && doorProduct.drill_3 !== undefined) {
                fromBottom.push(doorProduct.drill_3);
            }

            const hingeHoles = {};
            hingeHoles.side = doorProduct.drillside;
            hingeHoles.from_start = fromTop;
            hingeHoles.from_end = fromBottom;
            hingeHoles.centre = doorProduct.drill_4;
            hingeHoles.two_centre = doorProduct.drill_5;
            return hingeHoles;
        }
        return null;
    }

    this.collectDoorProductImageParams = function (doorProduct, product, params) {
        params = params ? params : {}

        params.api_code = "sloping_door";
        params.product_width = doorProduct.width ? doorProduct.width : product.width;
        params.product_height = product.height;

        params.rotategrain = product.rotate_grain;

        params.midrail = doorProduct.midrail;

        params.drillside = doorProduct.drillside;
        params.drill_0 = doorProduct.drill_0;
        params.drill_1 = doorProduct.drill_1;
        params.drill_2 = doorProduct.drill_2;
        params.drill_3 = doorProduct.drill_3;
        params.drill_3 = doorProduct.drill_3;
        params.drill_4 = doorProduct.drill_4;
        params.drill_5 = doorProduct.drill_5;

        params.left_angle_height = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_height : null;
        params.left_angle_width = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_width : null;
        params.right_angle_height = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_height : null;
        params.right_angle_width = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_width : null;

        return params;
    }

    this.applyDoorSlopingProducts = function (product) {


        const doorSlopingModelStateIDs = siteHelper.simpleCloneObject($rootScope.navigation_model.state_ids);
        doorSlopingModelStateIDs.parent_category_id = "door_sloping"
        doorSlopingModelStateIDs.api_code = "sloping_door"
        const doorSlopingModel = $rootScope.factory.product_door.getModel(doorSlopingModelStateIDs);

        let midrailHeight = product.option_term_values.midrail ? product.option_term_values.midrail.midrail_height : null;
        midrailHeight = midrailHeight ? midrailHeight : product.default_midrail_height;

        for (let i = 0; i < product.door_products.length; i++) {
            let doorProduct = product.door_products[i];
            if (!doorProduct.is_product_choice) {
                doorProduct = doorSlopingModel.birthChoice(doorProduct);
                doorSlopingModel.applyAcquiredChoice(doorProduct);
                product.door_products[i] = doorProduct;

                doorProduct.initialized = true;

                doorProduct.drillside = '';
                doorProduct.drill_0 = '';
                doorProduct.drill_1 = '';
                doorProduct.drill_2 = '';
                doorProduct.drill_3 = '';
                doorProduct.drill_4 = false;
                doorProduct.drill_5 = false;

                if (doorProduct.midrail_option) {
                    doorProduct.midrail = midrailHeight;
                } else {
                    doorProduct.midrail = false;
                }
            }

            siteHelper.applyValues(doorProduct, {
                collectImageParams: function () {
                    let params = this.super();

                    const doorProduct = this.root;
                    params = service.collectDoorProductImageParams(doorProduct, product, params);

                    return params;
                },
            });

        }
    }

}])